import { Locale } from './types'

export default {
    ERROR: {
        zstd_compress_failed: 'zstd compress failed',
        unknown_kind: 'unknown kind',
        mapack: 'mapack failed',
        plugin_build: 'failed to build the plugin',
        wrong_password: 'wrong password',
        bad_wheat_priority: 'bad wheat priority',
        bad_wheat_ard_json_data: 'Bad Wheat Json Data',
        reqwest_error: 'Reqwest Error',
        unknown: 'Unknown Error',
        bad_request: 'Bad Request',
        banned: 'You are banned',
        forbidden: 'Forbidden',
        bad_auth: 'Bad Authentication',
        not_found: 'Not Found',
        server_error: 'Server Error',
        database_error: 'Database Error',
        change_while_reordering: 'change while reordering is not allowed',
        index_out_of_bounds: 'index out of bounds',
        invalid_image: 'Invalid Image',
        encode_webp_error: 'Webp Encoding Failed',
        end_point_under_maintenance: 'this section is under maintenance',
        bad_username: 'invalid username',
        rate_limited: 'rate limited',
    },
    BOOL: {
        false: 'False',
        true: 'True',
    },
} satisfies Locale
